import { CHAMPION } from '../model/Champion';

const CHAMPIONS_TO_FROGSPAWN = {};
const FROGSPAWN_TO_CHAMPIONS = {};
[
    [ CHAMPION.BEAST, 'beast' ],
    [ CHAMPION.BLACKPANTHERCIVILWAR, 'black_panther_cw' ],
    [ CHAMPION.CIVILWARRIOR, 'civil_warrior' ],
    [ CHAMPION.FALCON, 'falcon' ],
    [ CHAMPION.GAMBIT, 'gambit' ],
    [ CHAMPION.PHOENIX, 'jean_grey' ],
    [ CHAMPION.KARNAK, 'karnak' ],
    [ CHAMPION.LOKI, 'loki' ],
    [ CHAMPION.NIGHTCRAWLER, 'nightcrawler' ],
    [ CHAMPION.QUAKE, 'quake' ],
    [ CHAMPION.ROGUE, 'rogue' ],
    [ CHAMPION.ULTRONCLASSIC, 'ultron_classic' ],
    [ CHAMPION.BLACKBOLT, 'black_bolt' ],
    [ CHAMPION.CAPTAINMARVEL, 'cap_marvel' ],
    [ CHAMPION.DRAX, 'drax' ],
    [ CHAMPION.GAMORA, 'gamora' ],
    [ CHAMPION.GROOT, 'groot' ],
    [ CHAMPION.KAMALAKHAN, 'kamala_khan' ],
    [ CHAMPION.MSMARVEL, 'ms_marvel' ],
    [ CHAMPION.RONAN, 'ronan' ],
    [ CHAMPION.SPIDERMANBLACK, 'spiderman_black' ],
    [ CHAMPION.SUPERIORIRONMAN, 'superior_ironman' ],
    [ CHAMPION.THOR, 'thor' ],
    [ CHAMPION.VENOM, 'venom' ],
    [ CHAMPION.VENOMPOOL, 'venompool' ],
    [ CHAMPION.IRONMAN, 'ironman' ],
    [ CHAMPION.IRONPATRIOT, 'iron_patriot' ],
    [ CHAMPION.HULKBUSTER, 'hulkbuster' ],
    [ CHAMPION.KANG, 'kang' ],
    [ CHAMPION.ROCKET, 'rocket' ],
    [ CHAMPION.STARLORD, 'star_lord' ],
    [ CHAMPION.VISION, 'vision' ],
    [ CHAMPION.THEVISION, 'the_vision' ],
    [ CHAMPION.ULTRON, 'ultron' ],
    [ CHAMPION.WARMACHINE, 'warmachine' ],
    [ CHAMPION.COLOSSUS, 'colossus' ],
    [ CHAMPION.CYCLOPS, 'cyclops' ],
    [ CHAMPION.CYCLOPS90S, 'cyclops90' ],
    [ CHAMPION.DEADPOOL, 'deadpool' ],
    [ CHAMPION.DEADPOOLXFORCE, 'deadpool_x' ],
    [ CHAMPION.MAGNETO, 'magneto' ],
    [ CHAMPION.MAGNETOMARVELNOW, 'magneto_white' ],
    [ CHAMPION.STORM, 'storm' ],
    [ CHAMPION.WOLVERINE, 'wolverine' ],
    [ CHAMPION.WOLVERINEOLDMAN, 'oldman_logan' ],
    [ CHAMPION.X23, 'wolverine_x23' ],
    [ CHAMPION.AGENTVENOM, 'agent_venom' ],
    [ CHAMPION.BLACKPANTHER, 'black_panther' ],
    [ CHAMPION.BLACKWIDOW, 'black_widow' ],
    [ CHAMPION.CROSSBONES, 'crossbones' ],
    [ CHAMPION.DAREDEVIL, 'daredevil' ],
    [ CHAMPION.DAREDEVILNETFLIX, 'daredevil_netflix' ],
    [ CHAMPION.ELEKTRA, 'elektra' ],
    [ CHAMPION.HAWKEYE, 'hawkeye' ],
    [ CHAMPION.MOONKNIGHT, 'moonknight' ],
    [ CHAMPION.PUNISHER, 'punisher' ],
    [ CHAMPION.WINTERSOLDIER, 'wintersoldier' ],
    [ CHAMPION.ABOMINATION, 'abomination' ],
    [ CHAMPION.ANTMAN, 'antman' ],
    [ CHAMPION.CAPTAINAMERICA, 'cap_america' ],
    [ CHAMPION.CAPTAINAMERICAWWII, 'cap_america_wwii' ],
    [ CHAMPION.ELECTRO, 'electro' ],
    [ CHAMPION.HULK, 'hulk' ],
    [ CHAMPION.JOEFIXIT, 'joe_fixit' ],
    [ CHAMPION.LUKECAGE, 'luke_cage' ],
    [ CHAMPION.REDHULK, 'red_hulk' ],
    [ CHAMPION.RHINO, 'rhino' ],
    [ CHAMPION.SHEHULK, 'she_hulk' ],
    [ CHAMPION.SPIDERGWEN, 'spidergwen' ],
    [ CHAMPION.SPIDERMAN, 'spiderman' ],
    [ CHAMPION.SPIDERMANMORALES, 'spiderman_morales' ],
    [ CHAMPION.YELLOWJACKET, 'yellowjacket' ],
    [ CHAMPION.DRSTRANGE, 'dr_strange' ],
    [ CHAMPION.DRSTRANGEMARVELNOW, 'dr_strange_mn' ],
    [ CHAMPION.GUILLOTINE, 'guillotine' ],
    [ CHAMPION.IRONFIST, 'iron_fist' ],
    [ CHAMPION.IRONFISTWHITE, 'iron_fist_white' ],
    [ CHAMPION.JUGGERNAUT, 'juggernaut' ],
    [ CHAMPION.MAGIK, 'magik' ],
    [ CHAMPION.SCARLETWITCH, 'scarlet_witch' ],
    [ CHAMPION.THORJANEFOSTER, 'thor_jane_foster' ],
    [ CHAMPION.UNSTOPPABLECOLOSSUS, 'u_colossus' ],
    [ CHAMPION.MAESTRO, 'maestro' ],
].forEach(([ champion, frogspawn ]) => {
    CHAMPIONS_TO_FROGSPAWN[ champion ] = frogspawn;
    FROGSPAWN_TO_CHAMPIONS[ frogspawn ] = champion;
});

export { FROGSPAWN_TO_CHAMPIONS, CHAMPIONS_TO_FROGSPAWN };



// WEBPACK FOOTER //
// ./src/data/champions/frogspawn.js